import { render, staticRenderFns } from "./OTPPage.vue?vue&type=template&id=b826c910&scoped=true&"
import script from "./OTPPage.vue?vue&type=script&lang=js&"
export * from "./OTPPage.vue?vue&type=script&lang=js&"
import style0 from "./OTPPage.vue?vue&type=style&index=0&id=b826c910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b826c910",
  null
  
)

export default component.exports